import { render, staticRenderFns } from "./TemplatePages.vue?vue&type=template&id=1a4721f2&"
import script from "./TemplatePages.vue?vue&type=script&lang=js&"
export * from "./TemplatePages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports